// combine recurring and one time tax amounts if tax type, tax country, tax percentage and tax inclusive are the same
export default function getTotalTaxAmounts(
  recurringTaxAmounts,
  oneTimeTaxAmounts,
) {
  const totalTaxAmounts = [...recurringTaxAmounts];

  oneTimeTaxAmounts.forEach(oneTimeTaxAmount => {
    const existingTaxAmount = totalTaxAmounts.find(
      totalTaxAmount =>
        totalTaxAmount.country === oneTimeTaxAmount.country &&
        totalTaxAmount.percentage === oneTimeTaxAmount.percentage &&
        totalTaxAmount.inclusive === oneTimeTaxAmount.inclusive,
    );

    if (existingTaxAmount) {
      existingTaxAmount.amount =
        existingTaxAmount.amount + oneTimeTaxAmount.amount;
    } else {
      totalTaxAmounts.push(oneTimeTaxAmount);
    }
  });

  return totalTaxAmounts;
}
